import { useLocation } from "wouter";
import { usePageMeta } from "../../../hooks/usePageMeta";
import { LandingNav } from "./LandingNav";
import { LandingFooter } from "./LandingFooter";

interface NotFoundPageProps {
  readonly isDark: boolean;
  readonly onToggleTheme: () => void;
}

export function NotFoundPage({ isDark, onToggleTheme }: NotFoundPageProps) {
  const [, navigate] = useLocation();

  usePageMeta(
    "Page introuvable",
    "La page que vous cherchez n'existe pas sur Palnia."
  );

  return (
    <div className="min-h-screen bg-surface text-ink antialiased flex flex-col">
      <LandingNav isDark={isDark} onToggleTheme={onToggleTheme} />

      <main className="flex-1 flex items-center justify-center px-6">
        <div className="text-center max-w-md">
          <p className="text-6xl font-bold text-accent">404</p>
          <h1 className="mt-4 text-2xl font-bold text-ink">
            Page introuvable
          </h1>
          <p className="mt-3 text-ink-muted">
            La page que vous cherchez n'existe pas ou a été déplacée.
          </p>
          <button
            onClick={() => navigate("/")}
            className="mt-8 px-6 py-3 text-sm font-medium text-white bg-accent hover:bg-accent-hover rounded-xl transition-colors"
          >
            Retour à l'accueil
          </button>
        </div>
      </main>

      <LandingFooter />
    </div>
  );
}
